document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('.faq');

    faqSections.forEach(faqSection => {
        const detailsElements = faqSection.querySelectorAll('details');

        detailsElements.forEach(details => {
            const summary = details.querySelector('summary');
            const answer = details.querySelector('.answer');
            
            summary.addEventListener('click', function(e) {
                e.preventDefault();
                
                const isOpen = details.hasAttribute('open');
                
                if (!isOpen) {
                    detailsElements.forEach(otherDetails => {
                        if (otherDetails !== details && otherDetails.hasAttribute('open')) {
                            closeDetails(otherDetails);
                        }
                    });
                    
                    openDetails(details);
                } else {
                    closeDetails(details);
                }
            });

            if (!details.hasAttribute('open')) {
                answer.style.maxHeight = '0';
                answer.style.paddingBottom = '0';
                answer.classList.remove('is-open');
            } else {
                answer.classList.add('is-open');
                const scrollHeight = answer.scrollHeight;
                answer.style.maxHeight = (scrollHeight + 40) + 'px';
                answer.style.paddingBottom = '2.5rem';
            }
        });

        function openDetails(details) {
            const answer = details.querySelector('.answer');
            
            details.setAttribute('open', '');
            answer.classList.add('is-open');
            
            const scrollHeight = answer.scrollHeight;
            
            answer.style.maxHeight = (scrollHeight + 40) + 'px';
            answer.style.paddingBottom = '2.5rem'; 
        }

        function closeDetails(details) {
            const answer = details.querySelector('.answer');
            
            answer.classList.remove('is-open');
            
            answer.style.maxHeight = '0';
            answer.style.paddingBottom = '0';
            
            setTimeout(() => {
                details.removeAttribute('open');
            }, 200); 
        }
    });
});